import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './everyday-rewards-callback.scss';
import {
  everydayRewardsConnect,
} from '../../actions/everydayRewardsActions';
import Alert from 'constants/alert-messages';

/**
 * Everyday Rewards Callback
 * @returns JSX Element
 */
const EverydayRewardsCallback = () => {
  const dispatch = useDispatch();
  const [isError, setIsError] = useState(false);

  const everydayRewardsConnectLoaded = useSelector((state) => state.everydayRewardsStore.everydayRewardsConnectLoaded);
  const everydayRewardsConnectLoading = useSelector((state) => state.everydayRewardsStore.everydayRewardsConnectLoading);
  const everydayRewardsConnectError = useSelector((state) => state.everydayRewardsStore.everydayRewardsConnectError);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);

    const stateParam = queryParams.get('state');
    const authorizationCodeParam = queryParams.get('authcode');

    if (!stateParam || !authorizationCodeParam) {
      setIsError(true);
      return;
    }
  
    const [assignedGrandfatherClientNumber, accountId] = stateParam.split(';');
  
    if (!assignedGrandfatherClientNumber || !accountId) {
      setIsError(true);
      return;
    }
  
    dispatch(everydayRewardsConnect(assignedGrandfatherClientNumber, accountId, authorizationCodeParam));
  }, []);

  const renderContent = () => {
    if (everydayRewardsConnectError || isError) {
      return Alert.EDR_CONNECT_ERROR;
    }
    if (everydayRewardsConnectLoading) {
      return Alert.EDR_CONNECT_LOADING;
    }
    if (everydayRewardsConnectLoaded) {
      return Alert.EDR_CONNECT_LOADED;
    }
  };

  return <>
    {renderContent()}
  </>;
};

export default EverydayRewardsCallback;
